import { render, staticRenderFns } from "./AccountDashboard.vue?vue&type=template&id=0b783143&scoped=true"
import script from "./AccountDashboard.vue?vue&type=script&lang=js"
export * from "./AccountDashboard.vue?vue&type=script&lang=js"
import style0 from "./AccountDashboard.vue?vue&type=style&index=0&id=0b783143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b783143",
  null
  
)

export default component.exports